import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "flex flex-col items-start p-6 pb-4",
  "data-testid": "post-station-detail-sidebar"
}
const _hoisted_2 = { class: "flex items-start justify-between w-full" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = {
  class: "w-5 h-5 shrink-0",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_5 = ["d"]
const _hoisted_6 = { class: "absolute z-50 mt-2 flex flex-col overflow-hidden bg-white border border-gray-200 rounded-lg shadow-md py-2 min-w-[240px]" }
const _hoisted_7 = ["data-testid", "onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  class: "w-6 h-6",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_10 = ["d"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-left text-[14px] font-normal leading-[18px] tracking-[0.07px] text-[#68688D]" }, " Detalhes do domínio ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full border-t border-[#2F7F91]/25 mt-4" }, null, -1)
const _hoisted_13 = {
  key: 1,
  class: "flex flex-col items-center justify-center gap-4 py-16 text-center",
  "data-testid": "post-station-detail-error-state"
}
const _hoisted_14 = {
  class: "w-10 h-10 text-negative",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_15 = ["d"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-textPrimary" }, "Não foi possível carregar os detalhes do domínio", -1)
const _hoisted_17 = {
  key: 0,
  class: "text-sm text-neutral50",
  "data-testid": "post-station-detail-error-message"
}
const _hoisted_18 = {
  key: 2,
  class: "flex flex-col gap-4 pb-4"
}
const _hoisted_19 = { class: "flex flex-col divide-y divide-gray-200" }
const _hoisted_20 = {
  class: "flex items-center justify-between py-3",
  "data-testid": "post-station-detail-company-row"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm text-textPrimary" }, "Empresa", -1)
const _hoisted_22 = { class: "text-sm text-textPrimary text-right" }
const _hoisted_23 = {
  class: "flex items-center justify-between py-3",
  "data-testid": "post-station-detail-unit-row"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm text-textPrimary" }, "Unidade", -1)
const _hoisted_25 = { class: "text-sm text-textPrimary text-right" }
const _hoisted_26 = {
  class: "flex items-center justify-between py-3",
  "data-testid": "post-station-detail-schedule-row"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-sm text-textPrimary" }, "Escala", -1)
const _hoisted_28 = { class: "text-sm text-textPrimary text-right" }
const _hoisted_29 = { class: "flex flex-col gap-1 text-left" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-semibold uppercase tracking-wide text-neutral50" }, " Critérios avaliados ", -1)
const _hoisted_31 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_32 = ["data-testid"]
const _hoisted_33 = { class: "flex flex-col text-left" }
const _hoisted_34 = { class: "text-sm text-textPrimary" }
const _hoisted_35 = {
  key: 0,
  class: "text-xs text-neutral50"
}
const _hoisted_36 = {
  key: 1,
  class: "text-sm text-neutral50 py-3"
}
const _hoisted_37 = {
  key: 0,
  role: "note",
  "data-testid": "post-station-registration-blocked",
  class: "flex flex-col gap-1 rounded-md border border-alert bg-alert/10 px-4 py-3 text-left text-sm text-textPrimary"
}
const _hoisted_38 = { class: "font-bold" }
const _hoisted_39 = {
  key: 1,
  role: "note",
  "data-testid": "post-station-registration-not-evaluated",
  class: "flex flex-col gap-1 rounded-md bg-primary5 px-4 py-3 text-left text-sm text-textPrimary"
}
const _hoisted_40 = { class: "font-bold" }
const _hoisted_41 = {
  key: 2,
  role: "note",
  "data-testid": "post-station-registration-informative",
  class: "flex flex-col gap-1 rounded-md bg-primary5 px-4 py-3 text-left text-sm text-textPrimary"
}
const _hoisted_42 = { class: "font-bold" }
const _hoisted_43 = { class: "flex flex-wrap gap-2" }

import { computed, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import {
  mdiAlertCircleOutline,
  mdiCheckCircle,
  mdiChevronDown,
  mdiClockOutline,
  mdiClose,
  mdiCloseCircle,
  mdiMinusCircleOutline
} from '@mdi/js'

import BaseSidebar from '@/components/designSystem/Sidebar/BaseSidebar.vue'
import CardDutyWithDoctor from '@/components/designSystem/Cards/CardDutyWithDoctor.vue'
import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import PostStationDetailSkeleton from '@/components/designSystem/Skeleton/PostStationDetailSkeleton.vue'
import Network from '@/Network'
import type { StationRegistrationActivityRecord } from '@/Network/Services/StationService'
import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'
import { getApiErrorMessage } from '@/utils/apiError'

import PostStationFrozenRecordsTable from './PostStationFrozenRecordsTable.vue'
import {
  COMPLIANCE_STATE_TITLES,
  DOMAIN_CTA_LABELS,
  DOMAIN_KEY_TO_API,
  exceptionBadgeFor,
  REGISTRATION_BLOCKED_TITLE,
  REGISTRATION_INFORMATIVE_TEXT,
  REGISTRATION_INFORMATIVE_TITLE,
  REGISTRATION_LEG_LABELS,
  REGISTRATION_NOT_EVALUATED,
  REGISTRATION_NOT_EVALUATED_TEXT,
  REGISTRATION_NOT_REQUIRED_TITLE,
  registrationBlockedText
} from '../constants'
import { mapDomainDetail } from '../mappers'
import { resolveOpenStationRoute, resolveOriginRoute } from '../originRoutes'
import type { PostStationCompliance, PostStationDomainDrilldown, PostStationRow } from '../types'

type DomainKey = keyof PostStationCompliance

type DomainBadge = { label: string; color: 'green' | 'red' | 'gray'; icon: string }


export default /*#__PURE__*/_defineComponent({
  __name: 'PostStationDetailSidebar',
  props: {
    modelValue: { type: Boolean },
    row: {},
    evaluationId: {},
    initialDomainKey: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const router = useRouter()
const permissionsStore = usePermissionsStore()

// Declarado inline (não importado do LabelBadge.vue) para não quebrar o build
// webpack — o shim de .vue só expõe o export default.
const domains = computed(() => props.row?.detail.domains ?? [])
const selectedKey = ref<DomainKey | null>(null)
const isDomainMenuOpen = ref(false)

const selectedDomain = computed(
  () => domains.value.find((domain) => domain.key === selectedKey.value) ?? domains.value[0] ?? null
)

// Cache por domínio durante a sessão da sidebar (limpo a cada abertura):
// trocar de domínio e voltar não refaz a request.
const isLoading = ref(false)
const hasError = ref(false)
// Mensagem específica do service (permissão, rede...) exibida sob o título fixo.
const errorMessage = ref<string | null>(null)
const detailCache = ref<Partial<Record<DomainKey, PostStationDomainDrilldown>>>({})

const drilldown = computed(() =>
  selectedKey.value ? (detailCache.value[selectedKey.value] ?? null) : null
)

// Guard de corrida: só a request mais recente escreve loading/erro; respostas
// antigas ainda são cacheadas (o dado é por domínio).
let fetchSeq = 0

const fetchDomainDetail = async (key: DomainKey) => {
  if (props.evaluationId === null) return
  // Os registros tardios (Q28) são do PLANTÃO, não da avaliação: carregam em
  // paralelo, só no domínio de registro e sem atrasar o drill-down.
  const seq = ++fetchSeq
  if (key === 'registration' && props.row) void loadFrozenRecords(props.row, seq)
  isLoading.value = true
  hasError.value = false
  errorMessage.value = null
  try {
    const response = await Network.postStation.getDomainDetail(
      props.evaluationId,
      DOMAIN_KEY_TO_API[key]
    )
    detailCache.value[key] = mapDomainDetail(response)
    if (seq === fetchSeq) {
      isLoading.value = false
    }
  } catch (error) {
    if (seq === fetchSeq) {
      hasError.value = true
      errorMessage.value = getApiErrorMessage(
        error,
        'Não foi possível carregar os detalhes do domínio da avaliação'
      )
      isLoading.value = false
    }
  }
}

const toggleDomainMenu = () => {
  isDomainMenuOpen.value = !isDomainMenuOpen.value
}

const closeDomainMenu = () => {
  isDomainMenuOpen.value = false
}

const selectDomain = (key: DomainKey) => {
  selectedKey.value = key
  closeDomainMenu()
  if (detailCache.value[key]) {
    // Cache hit: invalida requests em voo (não podem mais mexer em loading/erro).
    fetchSeq += 1
    isLoading.value = false
    hasError.value = false
    return
  }
  fetchDomainDetail(key)
}

const retryFetch = () => {
  if (selectedKey.value) fetchDomainDetail(selectedKey.value)
}

// Cada abertura é uma nova sessão: zera cache/estados e busca o domínio inicial.
watch(
  () => props.modelValue,
  (isOpen) => {
    isDomainMenuOpen.value = false
    if (!isOpen) return

    detailCache.value = {}
    frozenRecords.value = []
    hasError.value = false
    fetchSeq += 1

    const initialKey = props.initialDomainKey ?? domains.value[0]?.key ?? null
    selectedKey.value = initialKey
    if (initialKey) {
      fetchDomainDetail(initialKey)
    } else {
      isLoading.value = false
    }
  }
)

const statusBadge = computed<DomainBadge>(() => {
  const state = drilldown.value?.state

  // Q1 — fora do time: selo neutro, nem aprovado nem reprovado.
  if (state === 'not_required') {
    return { label: REGISTRATION_NOT_REQUIRED_TITLE, color: 'gray', icon: mdiMinusCircleOutline }
  }

  if (selectedKey.value === 'exception' && drilldown.value?.criteria[0]?.actual) {
    const actual = drilldown.value.criteria[0].actual
    if (state === 'fail') {
      return { label: 'Reprovado – Excepcionalidade pendente', color: 'red', icon: mdiCloseCircle }
    }
    if (actual === 'Aprovado') {
      return {
        label: 'Aprovado – Excepcionalidade aprovada',
        color: 'green',
        icon: mdiCheckCircle
      }
    }
    if (actual === 'Sem pedido') {
      return {
        label: 'Aprovado – Sem pedido de excepcionalidade',
        color: 'green',
        icon: mdiCheckCircle
      }
    }
    // Recusado, Revertido, Cancelado → domínio OK mas excepcionalidade reprovada
    return {
      label: 'Aprovado – Excepcionalidade reprovada',
      color: 'green',
      icon: mdiCheckCircle
    }
  }

  if (state === 'fail') {
    return { label: 'Critérios reprovados', color: 'red', icon: mdiCloseCircle }
  }
  if (state === 'pending') {
    return { label: 'Avaliação pendente', color: 'gray', icon: mdiClockOutline }
  }
  return { label: 'Todos os critérios aprovados', color: 'green', icon: mdiCheckCircle }
})

const ctaLabel = computed(() =>
  selectedKey.value ? DOMAIN_CTA_LABELS[selectedKey.value] : 'Abrir módulo de origem'
)

// A origem vem da resposta do drill-down; a navegação desmonta o painel — não
// precisa fechar a sidebar antes.
const canOpenOrigin = computed(
  () => Boolean(drilldown.value) && selectedKey.value !== null && props.row !== null
)

const openOriginModule = () => {
  if (!drilldown.value || !selectedKey.value || !props.row) return
  router.push(resolveOriginRoute(selectedKey.value, drilldown.value.origin, props.row))
}

/* ----------------------------------------------------------------------- *
 * F4 — domínio `registration`: gate, CTAs e registros recebidos após o
 * fechamento (M5, balões ③, ④, ⑥ e ⑦).
 * ----------------------------------------------------------------------- */

const isRegistrationDomain = computed(() => selectedKey.value === 'registration')

/**
 * "Enviar registro" é gateado pela permissão de EMISSÃO do `ds-attendance`,
 * resolvida pelo grafo (empresa → unidade → escala) — por isso
 * `checkAnyRessources` e não `check`, igual ao Detalhes do Plantão.
 */
const canEmitActivityRecord = computed(() =>
  permissionsStore.checkAnyRessources({
    permission: AuthorizationPermissions.AttendanceEmitting,
    resourceType: AuthorizationResourcesAndSubjects.DsAttendance
  })
)

// O hub "Enviar registro" (M1/M2) mora no Detalhes do Plantão; a sidebar leva
// até lá em vez de duplicar o wizard de 5 passos dentro do painel.
const openStationHub = () => {
  if (!props.row) return
  router.push(resolveOpenStationRoute(props.row))
}

/** Q1 — fora do time: sem bloqueio, sem "não avaliado" e sem CTA de envio. */
const registrationNotRequired = computed(
  () => isRegistrationDomain.value && drilldown.value?.state === 'not_required'
)

/**
 * Banner de bloqueio: só quando o domínio REPROVOU. `registrationBlocking`
 * ausente = backend anterior à F4, e lá o registro bloqueia — afrouxar por
 * omissão anunciaria "informativo" um domínio que na prática segura o plantão.
 *
 * F4-FX1 (revisto) — a ausência de política vigente NÃO suprime mais o banner.
 * A correção do backend removeu apenas o rebaixamento para `PENDING`;
 * `resolveRegistrationBlocking` continua devolvendo `true` nesse caminho e
 * `NONE` continua mapeado para `FAIL`, então o plantão realmente para em
 * "Revisar". Quem afirma bloqueio (ou não-bloqueio) é sempre o backend; a tela
 * só rotula.
 */
const registrationBlocked = computed(
  () =>
    !registrationNotRequired.value &&
    isRegistrationDomain.value &&
    drilldown.value?.state === 'fail' &&
    drilldown.value?.registrationBlocking !== false
)

/**
 * Rótulo "Não avaliado" (balão ⑤ do M5): rotulagem, não veredito — e só onde é
 * verdade. Com o domínio REPROVADO quem fala é o banner acima (que já carrega a
 * frase "sem política de registro vigente"); anunciar "não avaliado" ali fazia a
 * sidebar contradizer o próprio grid, que pinta "Revisar" na mesma linha.
 */
const registrationNotEvaluated = computed(
  () =>
    !registrationNotRequired.value &&
    isRegistrationDomain.value &&
    props.row?.registrationPolicyInEffect === false &&
    drilldown.value?.state !== 'fail'
)

// A perna que falta é o único dado acionável do banner: vem dos critérios
// reprovados de check-in/check-out, e não de uma segunda leitura do registro.
const missingLegs = computed(() =>
  (drilldown.value?.criteria ?? [])
    .filter((criterion) => !criterion.passed && criterion.key in REGISTRATION_LEG_LABELS)
    .map((criterion) => REGISTRATION_LEG_LABELS[criterion.key])
)

const registrationBlockedMessage = computed(() =>
  registrationBlockedText(missingLegs.value, props.row?.registrationPolicyInEffect !== false)
)

/**
 * Q28 — os registros que chegaram DEPOIS do fechamento. Vêm do payload cru de
 * `GET /stations/:doctorStationId/registration` (o recorte achatado do
 * normalizador não os carrega).
 *
 * A leitura é acessória: se a rota não existir ou falhar, a sidebar segue
 * inteira e a tabela some — o estado de erro da sidebar é do drill-down, que é
 * o que o usuário veio ver.
 */
const frozenRecords = ref<StationRegistrationActivityRecord[]>([])
const registrationTimezone = ref<string | null>(null)

const loadFrozenRecords = async (row: PostStationRow, seq: number) => {
  frozenRecords.value = []
  registrationTimezone.value = null
  try {
    const registration = await Network.station?.getStationRegistration?.(row.doctorStationId)
    // I10 — a chamada é fire-and-forget e o plantão muda: sem o mesmo guard do
    // drill-down, fechar a sidebar de A e abrir a de B listava os registros
    // tardios DE A na tabela de B, com "Ver registro" apontando para outro
    // plantão.
    if (seq !== fetchSeq) return
    const raw = registration?.raw
    if (!raw) return
    registrationTimezone.value = raw.timezone ?? null
    frozenRecords.value = (raw.activityRecords ?? []).filter((record) => record.afterClosure)
  } catch (error) {
    if (seq !== fetchSeq) return
    console.error('Não foi possível carregar os registros do plantão', error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseSidebar, {
    "model-value": _ctx.modelValue,
    "background-color": "#FFFFFF",
    width: "550px",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => emit('update:modelValue', value))
  }, {
    header: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "flex items-center gap-1 text-xl font-bold text-textPrimary",
              "data-testid": "post-station-detail-domain-select",
              onClick: toggleDomainMenu
            }, [
              _createTextVNode(_toDisplayString(selectedDomain.value?.label) + " ", 1),
              (_openBlock(), _createElementBlock("svg", _hoisted_4, [
                _createElementVNode("path", {
                  d: _unref(mdiChevronDown),
                  fill: "currentColor"
                }, null, 8, _hoisted_5)
              ]))
            ]),
            (isDomainMenuOpen.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", {
                    class: "fixed inset-0 z-40",
                    "data-testid": "post-station-detail-domain-backdrop",
                    onClick: closeDomainMenu
                  }),
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(domains.value, (domain) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: domain.key,
                        type: "button",
                        class: _normalizeClass(["flex w-full px-4 py-2 text-left text-sm hover:bg-gray-100", 
                    domain.key === selectedKey.value ? 'font-bold text-primary' : 'text-textPrimary'
                  ]),
                        "data-testid": `post-station-detail-domain-${domain.key}-item`,
                        onClick: ($event: any) => (selectDomain(domain.key))
                      }, _toDisplayString(domain.label), 11, _hoisted_7))
                    }), 128))
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "text-textPrimary hover:text-textPrimary/50 transition mt-1",
            "data-testid": "post-station-detail-close-button",
            onClick: close
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_9, [
              _createElementVNode("path", {
                d: _unref(mdiClose),
                fill: "currentColor"
              }, null, 8, _hoisted_10)
            ]))
          ], 8, _hoisted_8)
        ]),
        _hoisted_11,
        _hoisted_12
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(FilledButton, {
        text: ctaLabel.value,
        width: "100%",
        class: "!bg-primary30",
        disabled: !canOpenOrigin.value,
        "data-testid": "open-origin-module-button",
        onClick: openOriginModule
      }, null, 8, ["text", "disabled"])
    ]),
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createBlock(PostStationDetailSkeleton, { key: 0 }))
        : (hasError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_openBlock(), _createElementBlock("svg", _hoisted_14, [
                _createElementVNode("path", {
                  d: _unref(mdiAlertCircleOutline),
                  fill: "currentColor"
                }, null, 8, _hoisted_15)
              ])),
              _hoisted_16,
              (errorMessage.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(errorMessage.value), 1))
                : _createCommentVNode("", true),
              _createVNode(OutlinedButton, {
                text: "Tentar novamente",
                width: "200px",
                "data-testid": "post-station-detail-retry-button",
                onClick: retryFetch
              })
            ]))
          : (_ctx.row && drilldown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(CardDutyWithDoctor, {
                  formation: drilldown.value.formation ?? _ctx.row.detail.formation,
                  team: drilldown.value.team ?? _ctx.row.detail.team,
                  position: drilldown.value.position ?? _ctx.row.detail.position,
                  shift: drilldown.value.shift ?? _ctx.row.detail.shift,
                  "duty-label": _ctx.row.detail.dutyLabel,
                  "doctor-name": drilldown.value.doctor.name,
                  "doctor-crm": drilldown.value.doctor.crm,
                  "avatar-url": drilldown.value.doctor.avatarUrl,
                  active: false,
                  "show-requirements": true,
                  "data-testid": "post-station-detail-doctor-card"
                }, null, 8, ["formation", "team", "position", "shift", "duty-label", "doctor-name", "doctor-crm", "avatar-url"]),
                _createVNode(LabelBadge, {
                  label: statusBadge.value.label,
                  color: statusBadge.value.color,
                  icon: statusBadge.value.icon
                }, null, 8, ["label", "color", "icon"]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("span", _hoisted_22, _toDisplayString(drilldown.value.company), 1)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("span", _hoisted_25, _toDisplayString(drilldown.value.unit), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("span", _hoisted_28, _toDisplayString(drilldown.value.schedule), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  (drilldown.value.criteria.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(drilldown.value.criteria, (criterion, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: criterion.key,
                            class: "flex items-center justify-between gap-4 py-3",
                            "data-testid": `post-station-detail-criterion-${index}`
                          }, [
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("span", _hoisted_34, _toDisplayString(criterion.label), 1),
                              (criterion.description)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(criterion.description), 1))
                                : _createCommentVNode("", true)
                            ]),
                            (selectedKey.value === 'exception' && criterion.actual)
                              ? (_openBlock(), _createBlock(LabelBadge, {
                                  key: 0,
                                  label: _unref(exceptionBadgeFor)(criterion.actual).label,
                                  color: _unref(exceptionBadgeFor)(criterion.actual).color,
                                  size: "small",
                                  icon: _unref(exceptionBadgeFor)(criterion.actual).icon
                                }, null, 8, ["label", "color", "icon"]))
                              : (registrationNotRequired.value && !criterion.passed)
                                ? (_openBlock(), _createBlock(LabelBadge, {
                                    key: 1,
                                    label: _unref(COMPLIANCE_STATE_TITLES).not_required,
                                    color: "gray",
                                    size: "small",
                                    icon: _unref(mdiMinusCircleOutline),
                                    "data-testid": `post-station-detail-criterion-${index}-not-required`
                                  }, null, 8, ["label", "icon", "data-testid"]))
                                : (_openBlock(), _createBlock(LabelBadge, {
                                    key: 2,
                                    label: criterion.passed ? 'Sim' : 'Não',
                                    color: criterion.passed ? 'green' : 'red',
                                    size: "small",
                                    icon: criterion.passed ? _unref(mdiCheckCircle) : _unref(mdiCloseCircle)
                                  }, null, 8, ["label", "color", "icon"]))
                          ], 8, _hoisted_32))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_36, "Nenhum critério avaliado neste domínio."))
                ]),
                (isRegistrationDomain.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (registrationBlocked.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(REGISTRATION_BLOCKED_TITLE)), 1),
                            _createElementVNode("span", null, _toDisplayString(registrationBlockedMessage.value), 1)
                          ]))
                        : (registrationNotEvaluated.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(REGISTRATION_NOT_EVALUATED)), 1),
                              _createElementVNode("span", null, _toDisplayString(_unref(REGISTRATION_NOT_EVALUATED_TEXT)), 1)
                            ]))
                          : (drilldown.value.registrationBlocking === false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(REGISTRATION_INFORMATIVE_TITLE)), 1),
                                _createElementVNode("span", null, _toDisplayString(_unref(REGISTRATION_INFORMATIVE_TEXT)), 1)
                              ]))
                            : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "rounded-md border border-primary30 px-3 py-2 text-sm text-primary30",
                          "data-testid": "post-station-registration-view-record-button",
                          onClick: openOriginModule
                        }, " Ver registro "),
                        (canEmitActivityRecord.value && !registrationNotRequired.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "rounded-md border border-primary30 px-3 py-2 text-sm text-primary30",
                              "data-testid": "post-station-registration-send-record-button",
                              onClick: openStationHub
                            }, " Enviar registro "))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(PostStationFrozenRecordsTable, {
                        records: frozenRecords.value,
                        timezone: registrationTimezone.value,
                        onViewRecord: openOriginModule
                      }, null, 8, ["records", "timezone"])
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})